/**
 * My Kitty Theme - Interactive Animations & Effects
 */
(function() {
  'use strict';

  /* ============================================
     Scroll Reveal Animation
     ============================================ */
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    reveals.forEach(function(el) { observer.observe(el); });

    // Fallback: make all elements visible after 2 seconds in case Observer fails
    setTimeout(function() {
      reveals.forEach(function(el) {
        if (!el.classList.contains('visible')) {
          el.classList.add('visible');
        }
      });
    }, 2000);
  }

  /* ============================================
     Floating Decorations (Hearts, Stars, Paws)
     ============================================ */
  function createFloatingDecoration(container) {
    if (!container) return;
    var symbols = ['\u2764\ufe0f', '\u2b50', '\ud83c\udf1f', '\ud83d\udc96', '\ud83c\udf38', '\ud83d\udc3e'];
    var count = 12;

    for (var i = 0; i < count; i++) {
      var span = document.createElement('span');
      span.className = 'floating-deco';
      span.textContent = symbols[i % symbols.length];
      span.style.cssText =
        'position:absolute;pointer-events:none;font-size:' + (0.8 + Math.random() * 1.2) + 'rem;' +
        'left:' + (Math.random() * 100) + '%;' +
        'top:' + (Math.random() * 100) + '%;' +
        'animation:float ' + (2.5 + Math.random() * 3) + 's ease-in-out infinite;' +
        'animation-delay:' + (Math.random() * 3) + 's;' +
        'opacity:' + (0.3 + Math.random() * 0.4) + ';';
      container.appendChild(span);
    }
  }

  /* ============================================
     Sparkle Cursor Trail
     ============================================ */
  function initCursorSparkle() {
    var sparkles = [];
    var maxSparkles = 15;
    var throttle = false;

    document.addEventListener('mousemove', function(e) {
      if (throttle) return;
      throttle = true;
      setTimeout(function() { throttle = false; }, 80);

      var sparkle = document.createElement('div');
      sparkle.className = 'cursor-sparkle';
      sparkle.innerHTML = ['&#10022;', '&#10023;', '&#9733;'][Math.floor(Math.random() * 3)];
      sparkle.style.cssText =
        'position:fixed;pointer-events:none;z-index:9999;' +
        'left:' + e.clientX + 'px;top:' + e.clientY + 'px;' +
        'color:var(--color-primary);font-size:' + (0.6 + Math.random() * 0.8) + 'rem;' +
        'transition:all 0.8s ease-out;opacity:1;transform:scale(1);';
      document.body.appendChild(sparkle);
      sparkles.push(sparkle);

      requestAnimationFrame(function() {
        sparkle.style.opacity = '0';
        sparkle.style.transform = 'scale(0) translateY(-20px) rotate(180deg)';
      });

      setTimeout(function() {
        if (sparkle.parentNode) sparkle.parentNode.removeChild(sparkle);
        sparkles = sparkles.filter(function(s) { return s !== sparkle; });
      }, 800);

      if (sparkles.length > maxSparkles) {
        var old = sparkles.shift();
        if (old && old.parentNode) old.parentNode.removeChild(old);
      }
    });
  }

  /* ============================================
     Heart Burst Animation (Add to Cart)
     ============================================ */
  function fireHeartBurst(x, y) {
    for (var i = 0; i < 6; i++) {
      var heart = document.createElement('span');
      heart.textContent = '\u2764\ufe0f';
      heart.style.cssText =
        'position:fixed;pointer-events:none;z-index:9999;font-size:1.2rem;' +
        'left:' + x + 'px;top:' + y + 'px;' +
        'transition:all 0.8s cubic-bezier(0.25,0.46,0.45,0.94);opacity:1;';
      document.body.appendChild(heart);

      var angle = (i / 6) * Math.PI * 2;
      var dist = 40 + Math.random() * 30;
      requestAnimationFrame(function(h, a, d) {
        return function() {
          h.style.transform = 'translate(' + (Math.cos(a) * d) + 'px,' + (Math.sin(a) * d - 20) + 'px) scale(0)';
          h.style.opacity = '0';
        };
      }(heart, angle, dist));

      setTimeout(function(h) {
        return function() { if (h.parentNode) h.parentNode.removeChild(h); };
      }(heart), 800);
    }
  }

  /* ============================================
     Toast Notifications
     ============================================ */
  function showToast(message, type) {
    var toast = document.createElement('div');
    toast.className = 'kitty-toast kitty-toast--' + (type || 'success');
    toast.innerHTML = (type === 'error' ? '\ud83d\ude3f ' : '\ud83c\udf89 ') + message;
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }, 3000);
  }

  /* ============================================
     Format Money (simple USD)
     ============================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ============================================
     Update Cart Badge in Header
     ============================================ */
  function updateCartBadge(count) {
    var badges = document.querySelectorAll('.header__cart-count');
    if (count > 0) {
      if (badges.length > 0) {
        badges.forEach(function(b) { b.textContent = count; b.style.display = ''; });
      } else {
        var cartBtn = document.querySelector('.header__cart-btn');
        if (cartBtn) {
          var badge = document.createElement('span');
          badge.className = 'header__cart-count badge';
          badge.textContent = count;
          badge.style.animation = 'bounceIn 0.4s ease-out';
          cartBtn.appendChild(badge);
        }
      }
    } else {
      badges.forEach(function(b) { b.style.display = 'none'; });
    }
  }

  /* ============================================
     Mini Cart Drawer
     ============================================ */
  var miniCartEl = null;
  var miniCartOverlay = null;

  function initMiniCart() {
    // Inject spinner keyframe once
    if (!document.getElementById('mc-spin-style')) {
      var ss = document.createElement('style');
      ss.id = 'mc-spin-style';
      ss.textContent =
        '@keyframes mc-spin{to{transform:rotate(360deg)}}' +
        '.mini-cart__qty-spin{display:inline-block;animation:mc-spin 0.65s linear infinite;line-height:1}' +
        '.mini-cart__qty-controls.is-loading .mini-cart__qty-btn{opacity:0.35;pointer-events:none}';
      document.head.appendChild(ss);
    }

    miniCartOverlay = document.createElement('div');
    miniCartOverlay.className = 'mini-cart-overlay';
    document.body.appendChild(miniCartOverlay);

    miniCartEl = document.createElement('div');
    miniCartEl.className = 'mini-cart';
    miniCartEl.setAttribute('aria-hidden', 'true');
    miniCartEl.innerHTML =
      '<div class="mini-cart__header">' +
        '<span class="mini-cart__title">\ud83d\uded2 My Cart</span>' +
        '<button class="mini-cart__close" aria-label="Close cart">\u2715</button>' +
      '</div>' +
      '<div class="mini-cart__body" id="mini-cart-body">' +
        '<div class="mini-cart__loading">\u2728 Loading...</div>' +
      '</div>' +
      '<div class="mini-cart__footer" id="mini-cart-footer"></div>';
    document.body.appendChild(miniCartEl);

    miniCartEl.querySelector('.mini-cart__close').addEventListener('click', closeMiniCartFn);
    miniCartOverlay.addEventListener('click', closeMiniCartFn);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMiniCartFn();
    });
  }

  function closeMiniCartFn() {
    if (!miniCartEl) return;
    miniCartEl.classList.remove('is-open');
    miniCartOverlay.classList.remove('is-open');
    miniCartEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openMiniCart() {
    if (!miniCartEl) initMiniCart();
    miniCartEl.classList.add('is-open');
    miniCartOverlay.classList.add('is-open');
    miniCartEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchAndRenderMiniCart();
  }

  function fetchAndRenderMiniCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(renderMiniCart)
      .catch(function() {
        var body = document.getElementById('mini-cart-body');
        if (body) body.innerHTML = '<p class="mini-cart__error">\ud83d\ude3f Could not load cart.</p>';
      });
  }

  function renderMiniCart(cart) {
    var body = document.getElementById('mini-cart-body');
    var footer = document.getElementById('mini-cart-footer');
    if (!body || !footer) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="mini-cart__empty">' +
          '<div class="mini-cart__empty-icon">\ud83d\ude3f</div>' +
          '<p>Your cart is empty!</p>' +
          '<a href="/collections/all" class="btn btn-primary btn-sm" onclick="window.__mcClose&&window.__mcClose()">Shop Now \ud83d\uded2</a>' +
        '</div>';
      footer.innerHTML = '';
      return;
    }

    body.innerHTML = cart.items.map(function(item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.[^.?]+)(\?|$)/, '_160x160_crop_center$1$2')
        : '';
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + (item.product_title || '') + '" loading="lazy">'
        : '<div class="mini-cart__item-placeholder">\ud83c\udf81</div>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="mini-cart__item-variant">' + item.variant_title + '</span>'
        : '';
      return (
        '<div class="mini-cart__item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="mini-cart__item-img" onclick="window.__mcClose&&window.__mcClose()">' + imgHtml + '</a>' +
          '<div class="mini-cart__item-details">' +
            '<a href="' + item.url + '" class="mini-cart__item-title" onclick="window.__mcClose&&window.__mcClose()">' + item.product_title + '</a>' +
            variantHtml +
            '<div class="mini-cart__item-bottom">' +
              '<div class="mini-cart__qty-controls">' +
                '<button class="mini-cart__qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease">&#8722;</button>' +
                '<input type="number" class="mini-cart__qty-input" value="' + item.quantity + '" min="1" max="999" data-key="' + item.key + '" aria-label="Quantity">' +
                '<button class="mini-cart__qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase">&#43;</button>' +
              '</div>' +
              '<span class="price">' + formatMoney(item.line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="mini-cart__item-remove" data-key="' + item.key + '" aria-label="Remove item">\u2715</button>' +
        '</div>'
      );
    }).join('');

    var threshold = (window.__themeConfig && window.__themeConfig.freeShippingThreshold ? window.__themeConfig.freeShippingThreshold * 100 : 9900);
    var remaining = threshold - cart.total_price;
    var progress = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    var shippingHtml = remaining > 0
      ? '<div class="mini-cart__shipping">' +
          '<p class="mini-cart__shipping-text">\ud83d\ude9a Add <strong>' + formatMoney(remaining) + '</strong> for free shipping!</p>' +
          '<div class="mini-cart__shipping-bar"><div class="mini-cart__shipping-fill" style="width:' + progress + '%"></div></div>' +
        '</div>'
      : '<div class="mini-cart__shipping mini-cart__shipping--achieved">\ud83c\udf89 You unlocked <strong>FREE shipping!</strong></div>';

    footer.innerHTML =
      shippingHtml +
      '<div class="mini-cart__footer-inner">' +
        '<div class="mini-cart__subtotal"><span>Subtotal</span><span class="price price--large">' + formatMoney(cart.total_price) + '</span></div>' +
        '<p class="mini-cart__footer-note">Shipping &amp; taxes at checkout</p>' +
        '<div class="mini-cart__footer-actions">' +
          '<a href="/checkout" class="btn btn-primary btn-lg">\ud83d\udc96 Checkout</a>' +
        '</div>' +
      '</div>';

    body.querySelectorAll('.mini-cart__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.dataset.pending === '1') return;
        btn.dataset.pending = '1';
        setTimeout(function() { delete btn.dataset.pending; }, 600);
        var input = btn.closest('.mini-cart__qty-controls').querySelector('.mini-cart__qty-input');
        var qty = input ? (parseInt(input.value, 10) || 1) : (parseInt(btn.dataset.qty, 10) || 1);
        var newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        updateMiniCartItem(btn.dataset.key, newQty, btn);
      });
    });

    body.querySelectorAll('.mini-cart__qty-input').forEach(function(input) {
      input.addEventListener('change', function() {
        var newQty = parseInt(input.value, 10);
        if (isNaN(newQty) || newQty < 0) { input.value = 1; newQty = 1; }
        updateMiniCartItem(input.dataset.key, newQty, input);
      });
      // Prevent form submit on enter
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      });
    });

    body.querySelectorAll('.mini-cart__item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() { updateMiniCartItem(btn.dataset.key, 0, btn); });
    });
  }

  function updateMiniCartItem(key, quantity, triggerEl) {
    // Locate the item row and its qty controls
    var itemEl = triggerEl ? triggerEl.closest('.mini-cart__item') : null;
    var qtyControls = itemEl ? itemEl.querySelector('.mini-cart__qty-controls') : null;
    var qtyInput = itemEl ? itemEl.querySelector('.mini-cart__qty-input') : null;
    var oldQtyText = qtyInput ? qtyInput.value : '';

    // Per-item loading state (fast visual feedback)
    if (qtyControls) {
      qtyControls.classList.add('is-loading');
      if (qtyInput) qtyInput.disabled = true;
    }
    if (triggerEl && triggerEl.classList.contains('mini-cart__item-remove')) {
      triggerEl.disabled = true;
      triggerEl.style.opacity = '0.35';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw d; });
      return r.json();
    })
    .then(function(cart) {
      updateCartBadge(cart.item_count);
      renderMiniCart(cart);
    })
    .catch(function(err) {
      // Restore state on error
      if (qtyControls) {
        qtyControls.classList.remove('is-loading');
        if (qtySpan) qtySpan.textContent = oldQtyText;
      }
      if (triggerEl && triggerEl.classList.contains('mini-cart__item-remove')) {
        triggerEl.disabled = false;
        triggerEl.style.opacity = '';
      }
      var msg = (err && err.description) ? err.description : 'Could not update cart. Please try again.';
      showToast(msg, 'error');
    });
  }

  /* ============================================
     AJAX Add to Cart
     ============================================ */
  function initAjaxCart() {
    document.addEventListener('submit', function(e) {
      if (!e.target.hasAttribute('data-product-form')) return;
      e.preventDefault();

      var form = e.target;
      var btn = form.querySelector('#add-to-cart-btn');
      var originalHtml = btn ? btn.innerHTML : '';
      var rect = btn ? btn.getBoundingClientRect() : null;

      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '\u2728 Adding...';
        btn.classList.add('loading');
      }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function(r) {
          if (!r.ok) {
            return r.json().then(function(d) { throw d; });
          }
          return r.json();
        })
        .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
        .then(function(cart) {
          updateCartBadge(cart.item_count);
          if (rect) fireHeartBurst(rect.left + rect.width / 2, rect.top + rect.height / 2);
          if (btn) {
            btn.innerHTML = '\ud83d\udc96 Added!';
            btn.classList.remove('loading');
            setTimeout(function() { btn.disabled = false; btn.innerHTML = originalHtml; }, 2000);
          }
          openMiniCart();
        })
        .catch(function(err) {
          var msg = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
          showToast(msg, 'error');
          if (btn) { btn.disabled = false; btn.innerHTML = originalHtml; btn.classList.remove('loading'); }
        });
    });
  }

  /* ============================================
     Product Image Gallery
     ============================================ */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var mainImg = document.getElementById('main-product-img');
    if (!mainImg) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.96)';
        setTimeout(function() {
          mainImg.src = thumb.dataset.src;
          if (thumb.dataset.zoom) mainImg.dataset.zoom = thumb.dataset.zoom;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 180);
      });
    });
  }

  /* ============================================
     Image Lightbox
     ============================================ */
  function initImageLightbox() {
    var mainImg = document.getElementById('main-product-img');
    var lightbox = document.getElementById('product-lightbox');
    var overlay = document.getElementById('lightbox-overlay');
    var lightboxImg = document.getElementById('lightbox-img');
    var closeBtn = document.getElementById('lightbox-close');
    if (!mainImg || !lightbox || !overlay) return;

    mainImg.style.cursor = 'zoom-in';

    function openLightbox() {
      lightboxImg.src = mainImg.dataset.zoom || mainImg.src;
      lightboxImg.alt = mainImg.alt;
      lightbox.classList.add('is-open');
      overlay.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      overlay.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    mainImg.addEventListener('click', openLightbox);
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    overlay.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
    });
  }

  /* ============================================
     Variant Selector: Live Price Update
     ============================================ */
  function initVariantSelector() {
    var select = document.getElementById('variant-select');
    var singleInput = document.getElementById('variant-single-input');
    var priceEl = document.getElementById('product-price');
    var compareEl = document.getElementById('product-compare-price');
    var saveEl = document.getElementById('product-save-badge');

    if (!select && !singleInput) return;

    function updateVariantDisplayFromDataset(dataset) {
      var price = parseInt(dataset.price, 10) || 0;
      var compare = parseInt(dataset.comparePrice, 10) || 0;

      if (priceEl) priceEl.textContent = formatMoney(price);

      if (compare > price) {
        if (compareEl) { compareEl.textContent = formatMoney(compare); compareEl.style.display = ''; }
        if (saveEl) { saveEl.textContent = 'Save ' + formatMoney(compare - price) + ' \ud83c\udf89'; saveEl.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }

    // Multi-variant product (has select dropdown)
    if (select) {
      select.addEventListener('change', function() {
        var opt = select.options[select.selectedIndex];
        if (opt) {
          updateVariantDisplayFromDataset(opt.dataset);
        }
      });

      // Initialize price on page load for the currently selected variant
      if (select.options.length > 0) {
        var selectedOpt = select.options[select.selectedIndex];
        if (selectedOpt) {
          updateVariantDisplayFromDataset(selectedOpt.dataset);
        }
      }
    }
    // Single variant product (has hidden input)
    else if (singleInput) {
      updateVariantDisplayFromDataset(singleInput.dataset);
    }
  }

  /* ============================================
     Product Tabs
     ============================================ */
  function initProductTabs() {
    var tabBtns = document.querySelectorAll('.product-tab-btn');
    var panels = document.querySelectorAll('.product-tab-panel');
    if (!tabBtns.length) return;

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        tabBtns.forEach(function(b) { b.classList.remove('is-active'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = document.getElementById('tab-' + btn.dataset.tab);
        if (panel) panel.classList.add('is-active');
      });
    });

    // Click star rating → jump to reviews tab
    var ratingCount = document.querySelector('.product-info__rating-count');
    if (ratingCount) {
      ratingCount.addEventListener('click', function() {
        var reviewsBtn = document.querySelector('.product-tab-btn[data-tab="reviews"]');
        if (reviewsBtn) reviewsBtn.click();
        var tabSection = document.querySelector('.product-tabs');
        if (tabSection) tabSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* ============================================
     Review Form (localStorage-backed, no login)
     ============================================ */
  function initReviewForm() {
    var form = document.getElementById('review-submit-form');
    if (!form) return;

    var section = document.getElementById('reviews-section');
    var productHandle = section ? (section.dataset.product || 'product') : 'product';
    var storageKey = 'kitty-reviews-' + productHandle;

    // Star picker
    var starBtns = document.querySelectorAll('.review-star-btn');
    var ratingInput = document.getElementById('review-rating');
    var selectedRating = 0;

    starBtns.forEach(function(btn) {
      btn.addEventListener('mouseover', function() {
        var val = parseInt(btn.dataset.value, 10);
        starBtns.forEach(function(s, i) { s.classList.toggle('is-hover', i < val); });
      });
      btn.addEventListener('mouseout', function() {
        starBtns.forEach(function(s, i) {
          s.classList.remove('is-hover');
          s.classList.toggle('is-selected', i < selectedRating);
        });
      });
      btn.addEventListener('click', function() {
        selectedRating = parseInt(btn.dataset.value, 10);
        if (ratingInput) ratingInput.value = selectedRating;
        starBtns.forEach(function(s, i) { s.classList.toggle('is-selected', i < selectedRating); });
      });
    });

    // Multi-image (up to 4)
    var reviewImages = [];
    var maxImages = 4;
    var imgGrid = document.getElementById('review-img-grid');
    var imgInput = document.getElementById('review-image-input');
    var addImgBtn = document.getElementById('review-add-img-btn');

    function updateImageGrid() {
      if (!imgGrid) return;
      imgGrid.querySelectorAll('.review-img-thumb').forEach(function(el) { el.remove(); });
      reviewImages.forEach(function(src, idx) {
        var thumb = document.createElement('div');
        thumb.className = 'review-img-thumb';
        thumb.innerHTML =
          '<img src="' + src + '" alt="Photo ' + (idx + 1) + '">' +
          '<button type="button" class="review-img-remove" data-idx="' + idx + '" aria-label="Remove">\u00D7</button>';
        imgGrid.insertBefore(thumb, addImgBtn);
      });
      if (addImgBtn) addImgBtn.style.display = reviewImages.length >= maxImages ? 'none' : '';
    }

    if (imgInput) {
      imgInput.addEventListener('change', function() {
        var file = imgInput.files[0];
        imgInput.value = '';
        if (!file || reviewImages.length >= maxImages) return;
        var reader = new FileReader();
        reader.onload = function(e) { reviewImages.push(e.target.result); updateImageGrid(); };
        reader.readAsDataURL(file);
      });
    }
    if (imgGrid) {
      imgGrid.addEventListener('click', function(e) {
        var btn = e.target.closest('.review-img-remove');
        if (!btn) return;
        reviewImages.splice(parseInt(btn.dataset.idx, 10), 1);
        updateImageGrid();
      });
    }

    // Load / save / render user reviews
    function loadReviews() {
      try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); }
      catch (e) { return []; }
    }

    // Update product rating display (average stars + review count)
    function updateProductRating() {
      var starsEl = document.getElementById('product-reviews-stars');
      var countEl = document.getElementById('product-reviews-count');
      if (!starsEl || !countEl) return;

      var reviews = loadReviews();
      if (!reviews.length) {
        starsEl.innerHTML = '';
        countEl.innerHTML = '<a href="#tab-reviews" class="product-info__reviews-link">Be the first to review!</a>';
        return;
      }

      // Calculate average rating
      var total = 0;
      for (var i = 0; i < reviews.length; i++) {
        total += reviews[i].rating || 0;
      }
      var avgRating = Math.round(total / reviews.length * 10) / 10;

      // Render stars
      var fullStars = Math.floor(avgRating);
      var hasHalf = avgRating - fullStars >= 0.5;
      var emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
      var starHtml = '';
      for (var s = 0; s < fullStars; s++) starHtml += '\u2B50';
      if (hasHalf) starHtml += '\u2B50\uFE0E';
      for (var e = 0; e < emptyStars; e++) starHtml += '\u2606';

      starsEl.innerHTML = '<span class="product-info__stars">' + starHtml + '</span>';
      countEl.innerHTML = '<span class="product-info__rating-count">' + avgRating.toFixed(1) + ' (' + reviews.length + ' review' + (reviews.length > 1 ? 's' : '') + ')</span>';
    }
    function saveReviews(reviews) {
      try { localStorage.setItem(storageKey, JSON.stringify(reviews)); } catch (e) {}
    }
    function starsHtml(rating) {
      var html = '';
      for (var i = 0; i < 5; i++) html += '<span>' + (i < rating ? '\u2B50' : '\u2606') + '</span>';
      return html;
    }
    function renderUserReviews() {
      var list = document.getElementById('user-reviews-list');
      if (!list) return;
      var reviews = loadReviews();
      if (!reviews.length) {
        list.innerHTML = '<p class="reviews-empty">\uD83D\uDC3F No reviews yet — be the first to share your thoughts! \uD83D\uDC95</p>';
        return;
      }
      list.innerHTML = reviews.map(function(r) {
        var imgs = r.images || (r.image ? [r.image] : []);
        var photosHtml = imgs.map(function(src) {
          return '<img src="' + src + '" alt="Review photo" class="review-item__photo" data-review-photo="' + src + '">';
        }).join('');
        return (
          '<div class="review-item">' +
            '<div class="review-item__header">' +
              '<span class="review-item__name">' + escapeHtml(r.nickname) + '</span>' +
              '<span class="review-item__stars">' + starsHtml(r.rating) + '</span>' +
            '</div>' +
            (photosHtml ? '<div class="review-item__photos">' + photosHtml + '</div>' : '') +
            '<p class="review-item__text">\u201C' + escapeHtml(r.content) + '\u201D</p>' +
          '</div>'
        );
      }).join('');
    }
    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Review photo lightbox
    var reviewLightbox = null;
    var reviewLightboxImg = null;
    function openReviewPhoto(src) {
      if (!reviewLightbox) {
        reviewLightbox = document.createElement('div');
        reviewLightbox.className = 'review-photo-lightbox';
        reviewLightbox.innerHTML =
          '<button class="review-photo-lightbox__close" aria-label="Close">\u00D7</button>' +
          '<img class="review-photo-lightbox__img" src="" alt="Review photo">';
        document.body.appendChild(reviewLightbox);
        reviewLightboxImg = reviewLightbox.querySelector('img');
        reviewLightbox.querySelector('.review-photo-lightbox__close').addEventListener('click', closeReviewPhoto);
        reviewLightbox.addEventListener('click', function(e) {
          if (e.target === reviewLightbox) closeReviewPhoto();
        });
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && reviewLightbox && reviewLightbox.classList.contains('is-open')) closeReviewPhoto();
        });
      }
      reviewLightboxImg.src = src;
      reviewLightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeReviewPhoto() {
      if (reviewLightbox) reviewLightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Delegate click on review photos
    var reviewsSection = document.getElementById('reviews-section');
    if (reviewsSection) {
      reviewsSection.addEventListener('click', function(e) {
        var photo = e.target.closest('[data-review-photo]');
        if (photo) openReviewPhoto(photo.dataset.reviewPhoto);
      });
    }

    // Form submit
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var rating = parseInt(ratingInput ? ratingInput.value : 0, 10) || 0;
      var nicknameEl = document.getElementById('review-nickname');
      var emailEl = document.getElementById('review-email');
      var contentEl = document.getElementById('review-content');
      var nickname = nicknameEl ? nicknameEl.value.trim() : '';
      var email = emailEl ? emailEl.value.trim() : '';
      var content = contentEl ? contentEl.value.trim() : '';

      if (rating === 0) { showToast('Please select a star rating! \u2B50', 'error'); return; }
      if (!nickname || !content) { showToast('Nickname and review text are required! \uD83D\uDC31', 'error'); return; }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showToast('Please enter a valid email address! \uD83D\uDC8C', 'error'); return;
      }

      function doSubmit() {
        var reviews = loadReviews();
        reviews.unshift({ nickname: nickname, email: email, content: content, rating: rating, images: reviewImages.slice() });
        saveReviews(reviews);
        renderUserReviews();
        updateProductRating(); // Update rating display
        form.reset();
        selectedRating = 0;
        if (ratingInput) ratingInput.value = 0;
        starBtns.forEach(function(s) { s.classList.remove('is-selected', 'is-hover'); });
        reviewImages = [];
        updateImageGrid();
        showToast('Thank you for your review! \uD83D\uDC8C', 'success');
      }

      doSubmit();
    });

    renderUserReviews();

    // Update product rating display on page load
    updateProductRating();
  }


  /* ============================================
     Cart Page Enhancements
     ============================================ */
  function initCartEnhancements() {
    // Order note toggle
    var noteToggle = document.getElementById('cart-note-toggle');
    var noteBody = document.getElementById('cart-note-body');
    if (noteToggle && noteBody) {
      noteToggle.addEventListener('click', function() {
        var open = noteBody.classList.toggle('is-open');
        noteToggle.classList.toggle('is-open', open);
      });
    }
  }

  /* ============================================
     Cart AJAX Quantity Update
     ============================================ */
  function initCartAjaxQty() {
    var cartForm = document.getElementById('cart-form');
    if (!cartForm) return;

    // Prevent form submission - we handle all updates via AJAX
    cartForm.addEventListener('submit', function(e) {
      e.preventDefault();
    });

    // AJAX remove buttons
    cartForm.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-item__remove');
      if (!btn || !btn.dataset.key) return;
      doCartChange(btn.dataset.key, 0, null, btn);
    });

    // Listen for quantity changes on cart page inputs
    cartForm.addEventListener('change', function(e) {
      var input = e.target;
      if (!input.classList.contains('qty-input') || !input.dataset.key) return;

      var key = input.dataset.key;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;

      clearTimeout(input._debounce);
      input._debounce = setTimeout(function() {
        doCartChange(key, qty, input, null);
      }, 320);
    });
  }

  function doCartChange(key, qty, inputEl, removeBtn) {
    if (inputEl) inputEl.disabled = true;
    if (removeBtn) { removeBtn.disabled = true; removeBtn.style.opacity = '0.4'; }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw d; });
      return r.json();
    })
    .then(function(cart) {
      if (inputEl) inputEl.disabled = false;
      if (removeBtn) { removeBtn.disabled = false; removeBtn.style.opacity = ''; }

      var cartItemEl = inputEl ? inputEl.closest('.cart-item') : null;

      if (qty === 0 && cartItemEl) {
        // Animate out then remove row
        cartItemEl.classList.add('is-removing');
        setTimeout(function() {
          if (cartItemEl.parentNode) cartItemEl.parentNode.removeChild(cartItemEl);
          if (cart.item_count === 0) window.location.reload();
        }, 320);
      } else {
        // Update this row's line total
        var lineTotal = document.querySelector('[data-line-total="' + key + '"]');
        if (lineTotal) {
          var item = cart.items.filter(function(i) { return i.key === key; })[0];
          if (item) {
            lineTotal.style.transition = 'opacity 0.15s';
            lineTotal.style.opacity = '0';
            setTimeout(function() {
              lineTotal.textContent = formatMoney(item.line_price);
              lineTotal.style.opacity = '1';
            }, 150);
          }
        }
      }

      // Update summary totals
      var countEl = document.getElementById('cart-item-count');
      var subtotalEl = document.getElementById('cart-subtotal-price');
      var totalEl = document.getElementById('cart-total-price');

      if (countEl) countEl.textContent = cart.item_count;
      if (subtotalEl) {
        subtotalEl.style.transition = 'opacity 0.15s';
        subtotalEl.style.opacity = '0';
        setTimeout(function() {
          subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
          subtotalEl.style.opacity = '1';
        }, 150);
      }
      if (totalEl) {
        totalEl.style.transition = 'opacity 0.15s';
        totalEl.style.opacity = '0';
        setTimeout(function() {
          totalEl.textContent = formatMoney(cart.total_price);
          totalEl.style.opacity = '1';
        }, 150);
      }

      updateCartBadge(cart.item_count);
    })
    .catch(function(err) {
      if (inputEl) inputEl.disabled = false;
      if (removeBtn) { removeBtn.disabled = false; removeBtn.style.opacity = ''; }
      var msg = (err && err.description) ? err.description : 'Could not update cart. Please try again.';
      showToast(msg, 'error');
    });
  }

  /* ============================================
     Smooth Number Counter for Cart Badge
     ============================================ */
  function initCartBadgeAnimation() {
    document.querySelectorAll('.header__cart-count').forEach(function(badge) {
      badge.style.transition = 'transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)';
    });
  }

  /* ============================================
     Product Card Tilt Effect
     ============================================ */
  function initCardTilt() {
    document.querySelectorAll('.product-card').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var rotateX = (y - rect.height / 2) / 18;
        var rotateY = (rect.width / 2 - x) / 18;
        card.style.transform =
          'perspective(900px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-10px) scale(1.02)';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transition = 'transform 0.5s cubic-bezier(0.34,1.56,0.64,1)';
        card.style.transform = '';
        setTimeout(function() { card.style.transition = ''; }, 500);
      });
    });
  }

  /* ============================================
     Wishlist Heart Toggle
     ============================================ */
  function initWishlist() {
    // Load from localStorage
    var wished = JSON.parse(localStorage.getItem('kitty-wishlist') || '[]');

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__wish');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var card = btn.closest('.product-card');
      var productId = card ? (card.dataset.productId || '') : '';
      var isWished = btn.classList.toggle('is-wished');

      // Heart burst
      var rect = btn.getBoundingClientRect();
      fireHeartBurst(rect.left + rect.width / 2, rect.top + rect.height / 2);

      // Bounce animation
      btn.style.animation = 'none';
      requestAnimationFrame(function() {
        btn.style.animation = 'wishBounce 0.5s cubic-bezier(0.34,1.56,0.64,1)';
      });

      // Persist
      if (productId) {
        if (isWished) {
          if (wished.indexOf(productId) === -1) wished.push(productId);
        } else {
          wished = wished.filter(function(id) { return id !== productId; });
        }
        localStorage.setItem('kitty-wishlist', JSON.stringify(wished));
      }
    });

    // Restore state
    wished.forEach(function(id) {
      var card = document.querySelector('.product-card[data-product-id="' + id + '"]');
      if (card) {
        var btn = card.querySelector('.product-card__wish');
        if (btn) btn.classList.add('is-wished');
      }
    });
  }

  /* ============================================
     Homepage Card Quick-Add (AJAX, no navigation)
     ============================================ */
  function initCardQuickAdd() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__cta-btn');
      if (!btn) return;
      // Stop the click from bubbling to any parent <a> tag
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return; // placeholder card — do nothing
      if (btn.disabled) return; // prevent double-click

      var originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('loading');
      btn.innerHTML = '\u2728 Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(d) { throw d; });
        return r.json();
      })
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        updateCartBadge(cart.item_count);

        // Success state on button
        btn.classList.remove('loading');
        btn.classList.add('added');
        btn.innerHTML = '\ud83d\udc96 Added!';

        // Heart burst from button center
        var rect = btn.getBoundingClientRect();
        fireHeartBurst(rect.left + rect.width / 2, rect.top + rect.height / 2);

        // Open mini-cart
        openMiniCart();

        // Reset button after delay
        setTimeout(function() {
          btn.disabled = false;
          btn.classList.remove('added');
          btn.innerHTML = originalHtml;
        }, 2200);
      })
      .catch(function(err) {
        btn.disabled = false;
        btn.classList.remove('loading');
        btn.innerHTML = originalHtml;
        var msg = (err && err.description) ? err.description : 'Could not add to cart.';
        showToast(msg, 'error');
      });
    });
  }

  /* ============================================
     Button Ripple Effect
     ============================================ */
  function initButtonRipple() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.btn');
      if (!btn) return;

      var ripple = document.createElement('span');
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height) * 1.5;
      var x = e.clientX - rect.left - size / 2;
      var y = e.clientY - rect.top - size / 2;

      ripple.style.cssText =
        'position:absolute;border-radius:50%;pointer-events:none;' +
        'width:' + size + 'px;height:' + size + 'px;' +
        'left:' + x + 'px;top:' + y + 'px;' +
        'background:rgba(255,255,255,0.4);' +
        'transform:scale(0);animation:rippleOut 0.55s ease-out forwards;';

      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(ripple);
      setTimeout(function() { if (ripple.parentNode) ripple.parentNode.removeChild(ripple); }, 600);
    });
  }

  /* ============================================
     Cat Paw Click Animation
     ============================================ */
  function initPawClick() {
    // SVG path for a cute cat paw print
    var pawSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="52" height="52">' +
        // Main big pad
        '<ellipse cx="30" cy="42" rx="14" ry="11" fill="currentColor" opacity="0.85"/>' +
        // Toe bean top-left
        '<ellipse cx="12" cy="28" rx="7" ry="6" fill="currentColor" opacity="0.85" transform="rotate(-15 12 28)"/>' +
        // Toe bean top-center-left
        '<ellipse cx="23" cy="21" rx="7" ry="6" fill="currentColor" opacity="0.85" transform="rotate(-5 23 21)"/>' +
        // Toe bean top-center-right
        '<ellipse cx="37" cy="21" rx="7" ry="6" fill="currentColor" opacity="0.85" transform="rotate(5 37 21)"/>' +
        // Toe bean top-right
        '<ellipse cx="48" cy="28" rx="7" ry="6" fill="currentColor" opacity="0.85" transform="rotate(15 48 28)"/>' +
      '</svg>';

    var isTouch = 'ontouchstart' in window;
    if (isTouch) return; // skip on touch devices to avoid conflict

    document.addEventListener('click', function(e) {
      // Skip if clicking on interactive elements that have their own feedback
      if (e.target.closest('button, a, input, select, textarea, [role="button"]')) {
        // Still show paw but smaller and faster
        spawnPaw(e.clientX, e.clientY, 0.65);
      } else {
        spawnPaw(e.clientX, e.clientY, 1);
      }
    });

    function spawnPaw(x, y, scale) {
      var paw = document.createElement('div');
      paw.innerHTML = pawSvg;
      var size = 52 * scale;
      paw.style.cssText =
        'position:fixed;pointer-events:none;z-index:99999;' +
        'left:' + (x - size / 2) + 'px;' +
        'top:' + (y - size / 2) + 'px;' +
        'width:' + size + 'px;height:' + size + 'px;' +
        'color:var(--color-primary);' +
        'transform:scale(0) rotate(-20deg);' +
        'opacity:1;' +
        'transition:' +
          'transform 0.35s cubic-bezier(0.34,1.56,0.64,1),' +
          'opacity 0.3s ease 0.2s;';
      document.body.appendChild(paw);

      // Trigger spring-in
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          paw.style.transform = 'scale(1) rotate(0deg)';
        });
      });

      // Then fade out
      setTimeout(function() {
        paw.style.opacity = '0';
        paw.style.transform = 'scale(0.8) rotate(10deg) translateY(-8px)';
      }, 280);

      setTimeout(function() {
        if (paw.parentNode) paw.parentNode.removeChild(paw);
      }, 650);
    }
  }

  /* ============================================
     Quantity Selector Enhancement
     ============================================ */
  function initQuantitySelectors() {
    document.querySelectorAll('.qty-selector').forEach(function(wrapper) {
      var input = wrapper.querySelector('input');
      var minus = wrapper.querySelector('.qty-minus');
      var plus = wrapper.querySelector('.qty-plus');
      if (!input || !minus || !plus) return;

      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        var min = parseInt(input.min) || 0;
        if (val > min) { input.value = val - 1; input.dispatchEvent(new Event('change')); }
      });
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ============================================
     Header Scroll Float Effect
     ============================================ */
  function initHeaderScroll() {
    var header = document.querySelector('.header');
    if (!header) return;
    var threshold = 60;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================
     Mobile Menu Toggle
     ============================================ */
  function initMobileMenu() {
    var toggle = document.querySelector('.header__mobile-toggle');
    var nav = document.querySelector('.header__nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      nav.classList.toggle('is-open');
      toggle.classList.toggle('is-active');
      document.body.style.overflow = nav.classList.contains('is-open') ? 'hidden' : '';
    });

    nav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        nav.classList.remove('is-open');
        toggle.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    });
  }

  /* ============================================
     Header Cart Button - Open Mini Cart
     ============================================ */
  function initHeaderCartBtn() {
    var cartBtn = document.getElementById('header-cart-btn');
    if (!cartBtn) return;
    cartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openMiniCart();
    });
  }

  /* ============================================
     Orders Drawer
     ============================================ */
  function initOrdersDrawer() {
    var ordersBtn = document.getElementById('header-orders-btn');
    var drawer = document.getElementById('orders-drawer');
    if (!ordersBtn || !drawer) return;

    // Move to document.body to escape header's backdrop-filter stacking context
    document.body.appendChild(drawer);

    var overlay = document.getElementById('orders-overlay');
    var closeBtn = document.getElementById('orders-close');
    if (!ordersBtn || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    ordersBtn.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }
  /* ============================================
     Smooth Scroll to Top
     ============================================ */
  function initScrollToTop() {
    var btn = document.querySelector('.scroll-to-top');
    if (!btn) return;

    window.addEventListener('scroll', function() {
      btn.classList.toggle('visible', window.scrollY > 400);
    });

    btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ============================================
     Initialize Everything
     ============================================ */
  function init() {
    initScrollReveal();
    initCursorSparkle();
    initCartBadgeAnimation();
    initCardTilt();
    initWishlist();
    initCardQuickAdd();
    // initButtonRipple(); // Disabled - causes click issues on mobile buttons
 // Instead, add a simple CSS-based solution
    initQuantitySelectors();
    initMobileMenu();
    initHeaderScroll();
    initScrollToTop();

    // Product page
    initProductGallery();
    initImageLightbox();
    initVariantSelector();
    initProductTabs();
    initReviewForm();

    // AJAX cart
    initMiniCart();
    initAjaxCart();
    initHeaderCartBtn();
    initOrdersDrawer();

    // Cart page
    initCartEnhancements();
    initCartAjaxQty();

    // Init floating decorations on hero sections
    document.querySelectorAll('.floating-area').forEach(createFloatingDecoration);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Global handle for mini-cart close (used in inline onclick)
  window.__mcClose = closeMiniCartFn;
})();
